

export class CardInfo{
    cardType!: CardType;
    count!: number;
    description!: string;
}

export enum CardNews {
    GIFT_3_ELEPHANT = "GIFT_3_ELEPHANT",
}
export enum CardType {
    ELEPHANT = "ELEPHANT",
}

export class CardState {
    cardNews!: CardNews;
    elephantActive!: boolean;
}